import * as React from "react";
import Svg, { Path } from "react-native-svg";

function BluePencil(props) {
  return (
    <Svg width={36} height={37} viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M32.365 10.13L26.08 3.846a2.812 2.812 0 00-3.977 0L4.762 21.186a2.792 2.792 0 00-.824 1.99v6.284a2.813 2.813 0 002.812 2.812h23.625a1.687 1.687 0 100-3.375H17.578l14.787-14.79a2.814 2.814 0 000-3.977zm-13.24 1.47l1.547 1.547-9.985 9.985-1.546-1.547 9.984-9.985zM7.313 28.898v-4.359l2.182 2.181 2.177 2.178h-4.36zm7.312-1.828l-1.547-1.547 9.985-9.984 1.546 1.547-9.984 9.984zM27 14.694L21.516 9.21l2.579-2.58 5.484 5.485L27 14.695z"
        fill="#3E68FE"
      />
    </Svg>
  );
}

export default BluePencil;
